<script>
  import { push } from "svelte-spa-router"
  import { onMount } from "svelte"
  import Dialog from "./Dialog.svelte"
  import { targetSetId, vocabularySetId, questionnaireSetId, targetWords } from "./stores.js"
  import axios from "axios"

  const API_URL = process.env.API_URL
  const idPattern = /^[0-9a-zA-Z]{1,30}$/
  let tempId = ""
  let dialog
  let targetParam = ""
  let vocabularyParam = ""
  let questionnaireParam = ""
  let urlParamError = false

  onMount(async () => {
    // MEMO: マーケティング会社との連携のためトップページへのアクセスをアンケート画面にリダイレクト
    push("/questionnaire")

    scrollTo(0, 0)

    const urlParams = new URLSearchParams(window.location.search)
    targetParam = urlParams.get("t")
    vocabularyParam = urlParams.get("v")
    questionnaireParam = urlParams.get("q")

    if (!targetParam || !vocabularyParam || !questionnaireParam) {
      urlParamError = true
    } else {
      targetSetId.set(targetParam)
      vocabularySetId.set(vocabularyParam)
      questionnaireSetId.set(questionnaireParam)

      try {
        const apiUrl = API_URL + "/get_test"
        const params = new URLSearchParams({
          target: targetParam,
          vocabulary: vocabularyParam,
        })

        const response = await axios.get(`${apiUrl}?${params.toString()}`)

        let targetWordList = []
        if (response.data.target && response.data.vocabulary) {
          const targetData = response.data.target.Item
          targetWordList = targetData.target_words || []
        } else {
          const testList = response.data["test"].Items
          targetWordList = testList.filter((item) => item["kind"] == 0)
        }

        targetWords.set(targetWordList)
      } catch (error) {
        console.error("ターゲット語の事前取得に失敗しました:", error)
      }
    }
  })

  async function handleKeydown(event) {
    if (checkId()) {
      sessionStorage.setItem("id", tempId)
      openDialog()
    } else {
      document.getElementById("error-message").style.visibility = "visible"
    }
  }

  function openDialog() {
    dialog.showModal()
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) {
        dialog.close()
      }
    })
  }

  function closeDialog() {
    dialog.close()
  }

  function nextDialog() {
    push("/questionnaire")
  }

  function checkId() {
    return tempId.match(idPattern)
  }
</script>

<div class="wrapper">
  <div id="title">
    <h1>学習応援アプリ</h1>
  </div>
  <div id="agreement">
    <p>
      このアプリは、みなさんが学習や学校生活について、どのように考えているのかや、<br />
      どのように思っているのかを調べることができます。
    </p>
    <p>
      あなたが誰（だれ）なのかは、わからないようになっています。
    </p>
    <p>
      調査（ちょうさ）の内容（ないよう）を理解（りかい）し，協力してくれる人は，<br />
      利用者番号を入力して，確認（かくにん）ボタンを押（お）してください。
    </p>
  </div>
  <div id="input-id">
    <p style="font-weight: bold">利用者番号入力</p>
    <input id="input-area" bind:value={tempId} />
    <div
      id="error-message"
      style="visibility: {urlParamError ? 'visible' : 'hidden'}; color: red"
    >
      {urlParamError ? "URLが不正です" : "入力が不正です"}
    </div>
  </div>
  <div class="confirmation-button">
    <button
      class="indigo"
      on:click={handleKeydown}
      disabled={!targetParam || !vocabularyParam || !questionnaireParam}
      class:disabled={!tempId || urlParamError}
    >
      確認
    </button>
    <Dialog
      bind:dialog
      idNumber={tempId}
      text="番号に間違いがなければ進んでください"
      closeText="戻る"
      nextText="次へ"
      on:closeDialog={closeDialog}
      on:nextDialog={nextDialog}
    />
  </div>
</div>

<style lang="scss">
  h1 {
    margin-bottom: 10vh;
  }
  .wrapper {
    margin-left: 4vh;
    margin-right: 4vh;
  }
  #input-id {
    text-align: center;
    margin-top: 2em;
  }
  #input-area {
    width: 15em;
    height: 3em;
    padding-left: 2vh;
    padding-right: 2vh;
  }
  #title {
    text-align: center;
  }
  #agreement {
    margin: 1em;
  }
  .confirmation-button {
    text-align: center;
    margin-top: 10vh;
    .disabled {
      background-color: gray;
      border-color: gray;
      cursor: not-allowed;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .wrapper {
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
      padding: 0 2rem;
    }

    h1 {
      margin-bottom: 5vh;
      font-size: 2.5rem;
    }

    #input-area {
      width: 20em;
      height: 3.5em;
      font-size: 1.2rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    #agreement {
      margin: 2em;
      font-size: 1.1rem;
      line-height: 1.6;
    }

    #input-id {
      margin-top: 3em;
    }

    #input-id p {
      font-size: 1.2rem;
      margin-bottom: 1rem;
    }

    .confirmation-button {
      margin-top: 6vh;
    }
  }
</style>
